import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './App.css';
import './react-bootstrap-table.css';
import { Switch, Link, Route } from 'react-router-dom';
import database from './BD/database';
import firebase from 'firebase';
import uuidv4 from 'uuid/v4'
import Slide from './Globals/Slide/slide';
import Alert from 'react-s-alert';
import logo2 from '../img/loginLogo.png';
import { withRouter } from "react-router-dom";
import powered from '../img/powered.png';
import copyright from '../img/copyright.png';
import { Provider } from 'react-redux';
import { sendLog } from './../util'

import { Offline, Online } from "react-detect-offline"; //Libreria para la verificación de ka conexión a internet.

/*Importando el store de redux*/
import store from '../store';
import history from '../history';
/*Archivos para en enrutamiento*/

import * as XLSX from 'xlsx'

import Rutas from './Rutas/Rutas';
import newRutes from './Rutas/newRutes';
import cargaEmple from './Programacion/cargaEmple';
import ViajeNuevoA from './Programacion/nuevoViajeA';
import ViajeNuevo from './Programacion/nuevoViaje';
import NuevoTipo from './Programacion/selecionTipo';
import SelecionRango from './Programacion/selecionRango';
import Empleados from './Empleados/Empleados';
import Vehiculos from './Vehiculos/Vehiculos';
import TiposVehiculos from './Vehiculos/TiposVehiculos';
import TarifasVehiculos from './Tarifas/TarifasVehiculos';
import Empresa from './Empresa/Empresa';
import ViajesEmpleados from './Empleados_empresa/ViajesEmpleados';
import Viajes from './Empleados_empresa/Viajes';
import VehiculosBases from './Vehiculos_Bases/VehiculosBases';
import EmpleadoEmpresa from './Empleados_empresa/Empleados_empresa';
import Perfiles from './Perfiles/Perfiles';
import Informacion from './Informacion/Informacion';
import Usuarios from './Usuarios/Usuarios';
import Tarifas from './Tarifas/Tarifas';
import Home from './Home';
import Costos from './Costos/Costos';
import Asignar from './Asignar/Asignar';
import Reportes from './Reportes/Reportes';
import ReporteTemplate from './Reportes/ReporteTemplate';
import ReporteGeneralViajesEmpresa from './Reportes/ReporteGeneralViajesEmpresa';
import ReporteCalificaciones from './Reportes/ReporteCalificaciones';
import cambioViajes from './Programacion/cambioViajes';
import planiViajes from './Planificacion/planiViajes';
import planiViajesA from './PlanificacionE/planiViajes';
import ReservaEmpre from './Reservas/reservasEmpre';
import ReservaEmpreA from './Reservas/reservasEmpreA';
import AsignarConductor from './Reservas/asignarConductor';
import HomeEmple from './perfilEmpleado/homeEmple';
import TipoViajes from './Tipo_Viajes/TipoViajes';
import EstatusRutas from './Rutas/EstatusRutas';
import CancelacionViaje from './Rutas/CancelacionViaje';
import CambiarViaje from './Rutas/CambiarViaje';
import Swal from 'sweetalert2'

/*Reportes establecidos para los socios*/
import ReporteConductores from './Perfil_Socios/ReporteConductores';
import ReporteVehiculos from './Perfil_Socios/ReporteVehiculos';
import ReporteViajesConductores from './Perfil_Socios/ReporteViajesConductores';

/*Reportes establecidos para los socios*/




//Reporte de viajes de empleados por empresas
import DetalleViajesEmpresas from './ViajesEmpresas/DetalleViajesEmpresas';


/*Fin archivos para el enrutamiento*/

// mandatory
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';

//Components
import Content from './Globals/Content/Content';
import Emp_Empleados from './Emp_Empresas/Emp_Empleados';

import Menu from './Menu/Menu';
import TarifasAvianca from './Tarifas/TarifasAvianca';
import ReporteOperacionalA from './Reportes/ReporteOperacionalA';

var check;
class App extends Component {



	constructor(props) {
		super(props);
		this.state = {
			rutas: [],
			paginas: [],
			usuario: null,
			tipo: '',
			authUser: null,
			perfil_usuario: null,
			accesoKey: '',
			nodoEmpresa: '',
			nombreEmpresa: '',
			nodo_empresa: '',
			nombre_empresa: '',
			estado_usuario: true,
			existsEmpleado: false,
			existsUsuarioApp: false,
			existsUsuarioAcacya: false,
			existsSocios: false,
			datosClientes: [],
			isLoading: true,
			datosCentros: [],
			existSuperAdmin: false

		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.logout = this.logout.bind(this);
		this.empresaRef = database.ref().child('Empresa');
		this.renderContent = this.renderContent.bind(this);
		this.comprobarTipoUsuario = this.comprobarTipoUsuario.bind(this);
		this.renderRoutes = this.renderRoutes.bind(this);
		this.updateStateEmpresa = this.updateStateEmpresa.bind(this);
		this.guardarRutas = this.guardarRutas.bind(this);
		this.pushRutas = this.pushRutas.bind(this);
		this.makeRoutes = this.makeRoutes.bind(this);
		this.informacionPerfil = this.informacionPerfil.bind(this);
		this.cargaDatos = this.cargaDatos.bind(this);
		this.capturaDatos = this.capturaDatos.bind(this);
		this.setEmpresa();
	}


	static propTypes = {
		children: PropTypes.object.isRequired
	};

	componentDidMount() {

		firebase.auth().onAuthStateChanged(authUser => {
			if (authUser !== null) {
				this.guardarRutas();
				(firebase.auth().currentUser.uid !== null ? this.comprobarTipoUsuario() : '');
				authUser
					? this.setState(() => ({ authUser }))
					: this.setState(() => ({ authUser: null }));
			}
		});

	}

	async setEmpresa(){

		const snap = await firebase.database().ref().child('properties').child('empresa').once('value');
		const data = snap.val();

		store.dispatch({
			type: 'SET_EMPRESA',
			payload: data
		});
	}


	makeRoutes(x) {
		return x.route;
	}

	async verificarSesion(user_uid) {
		let response = true;
		const isUid = !!localStorage.getItem('uid');
		const uid = isUid ? JSON.parse(localStorage.getItem('uid')) : uuidv4();

		if (!isUid)	//no hay id en localstorage
			localStorage.setItem('uid', JSON.stringify(uid));

		const ref = firebase.database().ref(`/Usuarios_Acacya/${user_uid}/session_uid`);
		const snap = await ref.once('value');
		const data = await snap.val();

		if (!data)	//no hay sesion activa
			ref.set(uid);
		else {
			if (data != uid) { 	//sesion activa no coincide con sesion actual
				const result = await Swal.fire({
					title: 'Ya tiene otra sesion activa',
					text: "Cerrar las otras sesiones?",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Cerrar sesiones'
				});

				if (result.value) {	//acepta cerrar las otras sesiones
					ref.set(uid);
					localStorage.setItem('uid', JSON.stringify(uid));
					sendLog({ tipo: 'login_doble' });
				} else {
					sendLog({ tipo: 'login_doble_cancelado' });
					localStorage.removeItem('uid');
					response = false;
				}
			}
		}

		ref.on('value', async (snap) => {
			const isUid = !!localStorage.getItem('uid');
			const uid = isUid ? JSON.parse(localStorage.getItem('uid')) : uuidv4();

			if(isUid){
				const data  = await snap.val();
				if(data != uid){ 	//sesion activa no coincide con sesion actual
					await Swal.fire({
						title: 'Cerrando la sesion',
						text: "Ha iniciado sesion en otro dispositivo",
						type: 'warning',
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
					});
	
					this.logout();
					ref.off('value');
					if (isUid)
						localStorage.removeItem('uid');
				}

			}
		})

		return response;
	}

	logout(event) {


		this.state.tipo = null;
		this.setState(() => ({
			usuario: null,
			tipo: null,
			authUser: null,
			perfil_usuario: null,
			existsEmpleado: false,
			existsUsuarioAcacya: false,
			existsUsuarioApp: false,
			existsSocios: false,
			rutas: []
		}));

		firebase.auth().signOut().then(function () {

			history.push("/");

		}).catch(function (error) {

		});

	}


	informacionPerfil(uid) {

		database.ref().child('Usuarios_Acacya').orderByKey().equalTo(uid).on('value', this.gotDataUsuarioAcacya, this.errDataUsuarioAcacya);

	}

	gotDataUsuarioAcacya = (data) => {

		let perfil_usuario;

		let usuariodata = data.val();

		if (usuariodata != null) {

			let keys = Object.keys(usuariodata);

			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];

				perfil_usuario = usuariodata[k].perfil;

			}
			this.setState({ perfil_usuario: perfil_usuario });

			database.ref().child('Perfiles').orderByChild('nombre').equalTo(this.state.perfil_usuario).on("value", (snapshot) => {

				let accesoKey;

				let perfildata = snapshot.val();

				if (perfildata != null) {

					let keys = Object.keys(perfildata);

					for (let i = 0; i < keys.length; i++) {

						let k = keys[i];

						accesoKey = k;

					}
					this.setState({ accesoKey: accesoKey });
				}

				database.ref().child('Accesos').child(this.state.accesoKey).on("value", snapshotAccesos => {

					let paginas = [];
					let dataaccesos = snapshotAccesos.val();

					if (dataaccesos != null) {

						let keys = Object.keys(dataaccesos);

						for (let i = 0; i < keys.length; i++) {

							let k = keys[i];

							paginas.push({
								key: k,
								url: dataaccesos[k].url,
								nombre: dataaccesos[k].nombre,
								iconClass: dataaccesos[k].iconClass,
								orden: dataaccesos[k].orden
							})

						}

						paginas.sort((a, b) => a.orden - b.orden);
						this.setState({ paginas: paginas });
					}

				});

			});



		}
	}
	errDataUsuarioAcacya = (err) => {

		console.log(err);

	}





	guardarRutas() {


		this.state.rutas = [];

		let url;
		let route;
		let nombre;

		url = "/rutas";
		nombre = "Rutas";
		route = <Route path="/rutas" component={Rutas} />
		this.pushRutas(url, route, nombre);

		url = "/newRutes";
		nombre = "Crear Ruta";
		route = <Route path="/newRutes" component={newRutes} />
		this.pushRutas(url, route, nombre);

		url = "/tarifasAvianca";
		nombre = "Tarifas Avianca";
		route = <Route path="/tarifasAvianca" component={TarifasAvianca} />
		this.pushRutas(url, route, nombre);

		url = "/selecionTipo/:tipo";
		nombre = "seleccion";
		route = <Route path="/selecionTipo/:tipo" component={NuevoTipo} />
		this.pushRutas(url, route, nombre);

		url = "/nuevoViajeA";
		nombre = "Nuevo";
		route = <Route path="/nuevoViajeA" component={ViajeNuevoA} />
		this.pushRutas(url, route, nombre);

		url = "/planiViajesA";
		nombre = "planificacion";
		route = <Route path="/planiViajesA" component={planiViajes} />
		this.pushRutas(url, route, nombre);

		url = "/nuevoViaje";
		nombre = "Nuevo";
		route = <Route path="/nuevoViaje" component={ViajeNuevo} />
		this.pushRutas(url, route, nombre);

		url = "/selecionRango";
		nombre = "Rango";
		route = <Route path="/selecionRango" component={SelecionRango} />
		this.pushRutas(url, route, nombre);

		url = "/reservaE";
		nombre = "Reserva";
		route = <Route path="/reservaE" component={ReservaEmpreA} />
		this.pushRutas(url, route, nombre);

		url = "/vehiculos";
		nombre = "Vehiculos";
		route = <Route path="/vehiculos" component={Vehiculos} />;
		this.pushRutas(url, route, nombre);

		url = "/costos";
		nombre = "Costos";
		route = <Route path="/costos" component={AsignarConductor} />;
		this.pushRutas(url, route, nombre);

		url = "/asignar";
		nombre = "Reservas";
		route = <Route path="/asignar" component={Asignar} />;
		this.pushRutas(url, route, nombre);

		url = "/tipos_vehiculos";
		nombre = "Tipos de Vehiculos";
		route = <Route path="/tipos_vehiculos" component={TiposVehiculos} />
		this.pushRutas(url, route, nombre);


		url = "/empleados";
		nombre = "Empleados";
		route = <Route path="/empleados" component={Empleados} />;
		this.pushRutas(url, route, nombre);

		url = "/empresa";
		nombre = "Empresa";
		route = <Route path="/empresa" component={Empresa} />;
		this.pushRutas(url, route, nombre);

		url = "/informacion";
		nombre = "Información";
		route = <Route path="/informacion" component={Informacion} />;
		this.pushRutas(url, route, nombre);

		url = "/perfiles";
		nombre = "Perfiles";
		route = <Route path="/perfiles" component={Perfiles} />
		this.pushRutas(url, route, nombre);

		url = "/tarifas";
		nombre = "Tarifas";
		route = <Route path="/tarifas" component={Tarifas} />
		this.pushRutas(url, route, nombre);

		url = "/tarifas_vehiculos";
		nombre = "Tarifas por servicio";
		route = <Route path="/tarifas_vehiculos" component={TarifasVehiculos} />
		this.pushRutas(url, route, nombre);

		url = "/usuarios";
		nombre = "Usuarios";
		route = <Route path="/usuarios" component={Usuarios} />
		this.pushRutas(url, route, nombre);

		url = "/vehiculos_bases/:base/:nombre";
		nombre = "vehiculos bases";
		route = <Route path="/vehiculos_bases/:base/:nombre" component={VehiculosBases} />
		this.pushRutas(url, route, nombre);

		url = "/empresa_empleados/:idempresa/:nombre";
		nombre = "Empleados Empresa";
		route = <Route path="/empresa_empleados/:idempresa/:nombre" component={EmpleadoEmpresa} />
		this.pushRutas(url, route, nombre);

		url = "/reportes";
		nombre = "Reportes";
		route = <Route path="/reportes" component={Reportes} />
		this.pushRutas(url, route, nombre);


		url = "/template";
		nombre = "Template";
		route = <Route path="/template" component={ReporteTemplate} />
		this.pushRutas(url, route, nombre);

		url = "/";
		nombre = "Home";
		route = <Route path="/" component={Home} />
		this.pushRutas(url, route, nombre);

		url = "/template";
		nombre = "Template";
		route = <Route path="/template" component={ReporteTemplate} />
		this.pushRutas(url, route, nombre);

		url = "/cargaemple";
		nombre = "Carga";
		route = <Route path="/cargaemple" component={cargaEmple} />
		this.pushRutas(url, route, nombre);

		url = "/tiposviajes";
		nombre = "Tipos Viajes";
		route = <Route path="/tiposviajes" component={TipoViajes} />
		this.pushRutas(url, route, nombre);

		url = "/reporte_operacionalA";
		nombre = "Reporte Operacional";
		route = <Route path="/reporte_operacionalA" component={ReporteOperacionalA} />
		this.pushRutas(url, route, nombre);

		url = "/estado_ruta";
		nombre = "Estado de Rutas";
		route = <Route path="/estado_ruta" component={EstatusRutas} />
		this.pushRutas(url, route, nombre);

		url = "/cancelar_viaje";
		nombre = ""
		route = <Route path="/cancelar_viaje" component={CancelacionViaje} />
		this.pushRutas(url, route, nombre);

		url = "/editar_viaje";
		nombre = ""
		route = <Route path="/editar_viaje" component={CambiarViaje} />
		this.pushRutas(url, route, nombre);
	}



	pushRutas = (url, route, nombre) => {
		this.state.rutas.push({
			url: url,
			route: route,
			nombre: nombre
		})
		this.setState({
			rutas: this.state.rutas
		})
	}



	comprobarTipoUsuario = async () => {

		this.setState({

			estado_usuario: true,
			existsEmpleado: false,
			existsUsuarioApp: false,
			existsUsuarioAcacya: false,
			existsSocios: false,
			existSuperAdmin: false
		})

		const snapshot = await database.ref().child('Empleados').child(firebase.auth().currentUser.uid).once("value");
		if (snapshot.exists()) {
			sendLog({ tipo: 'login_conductor_intento' });
			Swal.fire({
				type: 'warning',
				text: 'Para ingresar como conductor por favor utilice la aplicación disponible en la Playstore',
			});
			await firebase.auth().signOut();

			this.state.tipo = null;
			this.setState(() => ({
				usuario: null,
				tipo: null,
				authUser: null,
				perfil_usuario: null,
				existsEmpleado: false,
				existsUsuarioAcacya: false,
				existsUsuarioApp: false,
				existSuperAdmin: false,
				existsSocios: false,
				rutas: []
			}));
			return;
		}

		database.ref().child('Socios').child(firebase.auth().currentUser.uid).once("value").then(snapshot => {

			if (snapshot.exists()) {

				this.state.existsSocios = true;
				this.state.estado_usuario = snapshot.val().Estado;

			}
		});
		// database.ref().child('Clientes').child(firebase.auth().currentUser.uid).once("value").then(snapshot=>{

		// 	if(snapshot.exists()){

		// 		this.state.existsUsuarioApp=true;						

		// 	}
		// });

		const snapshot_Usuarios_Acacya = await database.ref().child('Usuarios_Acacya').child(firebase.auth().currentUser.uid).once("value");

		if (snapshot_Usuarios_Acacya.exists()) {
			const res = await this.verificarSesion(firebase.auth().currentUser.uid);

			if (!res) return;

			this.state.existsUsuarioAcacya = true;
			this.state.estado_usuario = snapshot_Usuarios_Acacya.val().estado;
		}

		database.ref().child('superAdmin').child(firebase.auth().currentUser.uid).once("value").then(snapshot => {

			if (snapshot.exists()) {

				this.state.existSuperAdmin = true;
				this.state.estado_usuario = snapshot.val().estado;

			}

		})

		const email = firebase.auth().currentUser.email;

		//aqui deberia salir algun modal para elegir que empresa se desea ver como tester empresa
		const uidEmpresa = (email == 'lmartinez@i-strategies.tech') ? 'KKuQPJ7VyKgQoFW9i9kE2vFAMGx1' : firebase.auth().currentUser.uid;

		//La logica comienza aqui si el usuario logueado es empresa,conductor,perfil de acacya o admin				
		database.ref().child('Empresa').child(uidEmpresa).once("value").then(snapshot => {

			if (snapshot.exists()) {

				//Actualiza el store de redux

				if (snapshot.val().estado === 'Activo') {

					this.updateStateEmpresa(uidEmpresa, snapshot.val().codigo_empresa);

					this.setState({

						usuario: firebase.auth().currentUser.email,
						tipo: 'empresa',
						nodoEmpresa: uidEmpresa,
						nombreEmpresa: snapshot.val().codigo_empresa
					});
					sendLog({ tipo: 'login', informacion_extra: {tipo: 'empresa' } });

				}
				else {
					Swal.fire({
						type: 'warning',
						text: 'Este usuario esta actualmente inactivo, comunicate con el administrador para más información',
					});

					firebase.auth().signOut().then(function () {
						this.state.tipo = null;
						this.setState(() => ({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existSuperAdmin: false,
							rutas: []
						}));
					}).catch(function (error) {
					});

				}



			}
			else if (this.state.existsUsuarioAcacya) {


				if (this.state.estado_usuario === 'Activo') {
					sendLog({ tipo: 'login', informacion_extra: {tipo: 'usuarioAcacya (Administrador)'} });
					this.informacionPerfil(firebase.auth().currentUser.uid);
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'perfil'
					});


				}
				else {
					Swal.fire({
						type: 'warning',
						text: 'Este usuario esta actualmente inactivo o suspendido, comunicate con el administrador para más información',
					});

					firebase.auth().signOut().then(function () {
						this.state.tipo = null;
						this.setState(() => ({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existSuperAdmin: false,
							existsSocios: false,
							rutas: []
						}));
					}).catch(function (error) {
					});


				}




			}
			else if (this.state.existsSocios) {

				if (this.state.estado_usuario === 'Activo') {

					this.setState({
						usuario: firebase.auth().currentUser.mail,
						tipo: 'socio'

					})

				}
				else {
					Swal.fire({
						type: 'warning',
						text: 'Este usuario esta actualmente inactivo o suspendido, comunicate con el administrador para más información',
					});
					firebase.auth().signOut().then(function () {
						this.state.tipo = null;
						this.setState(() => ({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existSuperAdmin: false,
							existsSocios: false,
							rutas: []
						}));
					}).catch(function (error) {
					});


				}


			}
			else if (this.state.existsEmpleado) {

				if (this.state.estado_usuario !== 'Inactivo' && this.state.estado_usuario !== 'Suspendido') {
					this.setState({
						usuario: firebase.auth().currentUser.mail,
						tipo: 'empleado'
					})
				}
				else {
					Swal.fire({
						type: 'warning',
						text: 'Este usuario esta actualmente inactivo o suspendido, comunicate con el administrador para más información',
					});

					firebase.auth().signOut().then(function () {
						this.state.tipo = null;
						this.setState(() => ({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existSuperAdmin: false,
							rutas: []
						}));
					}).catch(function (error) {

					});
				}
			}
			else {
				if (this.state.existSuperAdmin === true) {
					sendLog({ tipo: 'login', informacion_extra: {tipo: 'superAdmin'} });
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'admin'
					});
				}
				else {
					Swal.fire({
						type: 'warning',
						text: 'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.',
					});
				}

			}
		});

	}


	handleSubmit = async (event) => {
		const timeout = setTimeout(async ()=>{
			const result = await Swal.fire({
				type: 'warning',
				text: 'Está tardando mas de lo normal, vuelva a intentarlo',
			});

			if(result.value){
				const isUid = !!localStorage.getItem('uid');
				if (isUid)
					localStorage.removeItem('uid');
	
				this.logout();
			}
		}, 5000)
		try {
			//Credenciales
			let user = this.email.value;
			let pass = this.pass.value;
	
			const firebaseUser = await firebase.auth().signInWithEmailAndPassword(user, pass)
				// .then(firebaseUser => {
			clearTimeout(timeout);
			Swal.close();
			this.comprobarTipoUsuario();
				// })

			
		} catch (error) {
			clearTimeout(timeout);
			let errorCode = error.code;
			let errorMessage = error.message;
			if (errorCode === 'auth/user-not-found') {
				Swal.fire({
					type: 'warning',
					text: 'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.',
				});
			}
			else {
				Swal.fire({
					type: 'warning',
					text: 'La contraseña no es válida o el usuario no tiene una contraseña',
				});
			}
		}
		if (event)
			event.preventDefault();
	}

	cargaDatos(event) {
		let { datosCCosto, datosClientes } = this.state;
		let valor = 0;
		let key = 0;
		var keyCCosto = 0;
		var guardado = setInterval(() => {
			if (datosClientes[valor] === undefined) {
				clearInterval(guardado);
				return false;
			}
			//Encuentra el codigo del centro de costo
			function thisValue(cliente) {
				return cliente.codigo === datosClientes[valor].D;
			}
			//Guarda el centro de costo
			keyCCosto = datosCCosto.find(thisValue).key;
			firebase.auth().createUserWithEmailAndPassword(datosClientes[valor].I, datosClientes[valor].J).then(cliente => {
				key = cliente.uid;
				firebase.database().ref().child('Clientes/' + key).update({
					uid: key,
					nombre: datosClientes[valor].A,
					apellido: datosClientes[valor].B,
					areaDesc: datosClientes[valor].C,
					centro: keyCCosto,
					coordenadas: {
						coordenadas: {
							lat: datosClientes[valor].E,
							lng: datosClientes[valor].F
						},
						placeName: datosClientes[valor].G,
						referencia: ''
					},
					direccion: datosClientes[valor].G,
					referencias: datosClientes[valor].H,
					correo: datosClientes[valor].I,
					dui: datosClientes[valor].K,
					escalafon: datosClientes[valor].L,
					numero_empleado: datosClientes[valor].M,
					Viajes: '',
					estado: 'Activo',
					preferencia: 'Microbus',
					socio: 'EBcvChkwXRgDau5FpWtisCgsEpH3',
					subir: false,
					viaje: '',
					viajeActual: 'ninguno'
				}).then(() => {
					//Operacion completada
					// console.log("Exito index:" + valor);
					// console.log(datosClientes[valor - 1]);
				}).catch((error) => {
					//Error al crear cliente
					console.table([["Registro", datosClientes[valor].I], ["index", valor], ["errorCode", error.code], ["errorMessage", error.errorMessage]]);
					valor++;
				});
				//Verificar si se termino la coleccion para terminar el timeInterval
				valor++;
			}).catch((error) => {
				//Error al crear sesion
				console.table([["Registro", datosClientes[valor].I], ["index", valor], ["errorCode", error.code], ["errorMessage", error.errorMessage]]);
				valor++;
			});;
		}, 6000);
	}

	capturaDatos = (event) => {
		try {
			let datos = [];
			var done = false;
			var file = event.target.files[0];
			const reader = new FileReader();

			var check = setTimeout(() => {
				if (done == true) {
					this.setState({ datosClientes: datos, isLoading: false });
					clearTimeout(check);
				}
			}, 1000);

			reader.onloadend = (event) => {
				const bstr = event.target.result;
				const wb = XLSX.read(bstr, { type: 'binary' });

				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];

				const data = XLSX.utils.sheet_to_json(ws, { header: "A" });

				data.forEach((element, index) => {
					if (element.A === undefined) {
						element.A = "";
					}
					if (element.B === undefined) {
						element.B = "";
					}
					if (element.C === undefined) {
						element.C = "";
					}
					if (isNaN(element.D)) {
						console.table([["Error", "Usuario sin centro de costo"], ["Usuario", element.I], ["index", index]]);
						return false;
					}
					if (isNaN(element.E)) {
						element.E = "13.7012889";
						element.F = "-89.226622";
					}
					if (element.G === undefined) {
						element.G = "";
					}
					if (element.H === undefined) {
						element.H = "";
					}
					if (element.I === undefined || element.J === undefined) {
						console.table([["Sin usuario y contraseña: ", element], ["index", index]]);
						return false;
					}
					if (element.K === undefined) {
						element.K = "";
					}
					if (element.L == undefined) {
						element.L = "0";
					}
					else {
						if (element.L.length > 0) {
							element.L = element.L.substr(element.L.length - 3, element.L.length);
						}
						else {
							element.L = "0";
						}
					}
					if (element.M === undefined) {
						console.table([["Sin numero de empleado ", element], ["index", index]]);
						return false;
					}
					datos.push(element);
				});
				done = true;
			}
			reader.readAsBinaryString(file);
		}
		catch (error) {
			console.log(error.message);
		}
	}

	handleEnter = (evt) => {
		if (!evt.key || evt.key === 'Enter')
			this.handleSubmit();
	}

	renderContent() {
		const { children } = this.props;
		if (this.state.authUser !== null && this.state.tipo === 'admin') {
			return (
				<div>
					<Menu usuario={this.state.usuario} rutas='admin' />
					<Slide />
					<div className="container contenedor contenido">
						<Content body={children} />
					</div>
				</div>
			);
		} else if (this.state.authUser !== null && this.state.tipo === 'perfil' && this.state.paginas.length !== 0) {
			return (
				<div>
					<Menu usuario={this.state.usuario} rutas={this.state.paginas} />
					<Slide />
					{/* <button type="button" onClick={this.logout} className="btn btn-danger btn-sm salir">Cerrar Sesion</button>								 */}
				</div>
			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empleado') {
			return (<div><Menu usuario={this.state.usuario} rutas='empleado' /> </div>);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empresa') {
			return (<div><Slide /><Menu usuario={this.state.usuario} rutas='empresa' /> </div>);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'socio') {
			return (<div><Slide /><Menu usuario={this.state.usuario} rutas='socios' /></div>);
		}
		else {
			return (
				/* Para cargar datos
				<div className="login">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-sm">
								<label className="custom-file-label" for="excel">Seleccionar fila</label>
								<input type="file" className="custom-file-input" id="excel" onChange={this.capturaDatos}/>
							</div>
						</div>
						<div className="row justify-content-end">
							<div className="col-sm">
								<button type="button" disabled={this.state.isLoading} onClick={this.cargaDatos} className="btn btn-info pull-right">Guardar</button>
							</div>
						</div>
					</div>					
				</div>*/

				<div style={{ width: '100%', height: '100%' }} className='login'>
					<div style={{ width: '100%', height: '100%' }} className="container ">
						<div style={{ width: '100%', height: '100%' }} className="row align-items-center">
							<div className="col col-sm-1"></div>
							<div className="col col-sm-4 borderR">
								<img src={logo2} alt="logo" className="logo" style={{ width: '60%', height: '70%' }} />
							</div>
							<div className="col col-sm-1"></div>
							<div className="col col-sm-5">
								<h1 className="letras-login">ADMINISTRACIÓN WEB</h1>
								<br />
								<div className="form-group">
									<input style={{ borderRadius: 6 }} placeholder="Usuario" type="email" className="form-control" required
										onKeyUp={this.handleEnter}
										ref={input => { this.email = input; }} />
								</div>
								<div className=
								
								"form-group">
									<input style={{ borderRadius: 6 }} placeholder="Contraseña" type="password" className="form-control" required
										onKeyUp={this.handleEnter}
										ref={input => { this.pass = input; }} />
								</div>
								<br />
								<div className="form-group">
									<a style={{ color: '#ffffff', borderRadius: 6 }} className="submitButton" onClick={this.handleSubmit.bind(this)}>INGRESAR</a>
								</div>
							</div>
							<div style={{ width: '100%' }} class="row align-items-center">
								<div className="col col-sm-5">
								</div>

							</div>
						</div>

					</div>

					<footer className="footer mt-auto py-3" style={{ width: '100%' }}>
						<div className="login-flex">

							<div>
								<img src={powered} style={{ marginTop: '10%', width: '70%', marginLeft: '20%' }} />
							</div>
							<div>
								<img src={copyright} style={{ marginTop: '10%' }} />
							</div>
						</div>
					</footer>
					{/* <span style={{ fontFamily: 'Gotham', color: 'white', fontWeight: 'bold', fontSize: '0.8em', textAlign: 'center' }}>Copyrigth &copy; Todos los derechos reservados, i-Strategies 2018</span> */}
				</div>
			);
		}
	}

	renderRoutes() {


		if (this.state.perfil_usuario != null && this.state.paginas.length !== 0) {

			let newAccesos = []
			for (let i = 0; i < this.state.paginas.length; i++) {


				let obj = this.state.rutas.find(rutas => rutas.url === this.state.paginas[i].url);



				if (obj !== undefined) {


					if (obj.nombre === 'Empresa') {

						let routeEmpresa = <Route path="/empresa_empleados/:idempresa/:nombre" component={EmpleadoEmpresa} />

						newAccesos.push({

							url: '/empresa_empleados/:idempresa/:nombre',
							route: routeEmpresa,
							nombre: 'Empleados Empresa'

						})


					}
					else if (obj.nombre === 'Bases') {

						let routeBases = <Route path="/vehiculos_bases/:base/:nombre" component={VehiculosBases} />

						newAccesos.push({

							url: '/vehiculos_bases/:base/:nombre',
							route: routeBases,
							nombre: 'Vehiculos Bases'

						})

					}



					newAccesos.push({
						url: obj.url,
						route: obj.route,
						nombre: obj.nombre
					})

				}


			}
			this.state.rutas = newAccesos;


		}


		if (this.state.authUser !== null && this.state.tipo === 'admin') {

			return (

				<Switch>
					<Route path="/reporte_viajes_empresa" component={ReporteGeneralViajesEmpresa} />
					<Route path="/reporte_operacionalA" component={ReporteOperacionalA} />
					<Route path="/detalle_viajes/:empresa" component={DetalleViajesEmpresas} />
					<Route path="/reporte_calificaciones" component={ReporteCalificaciones} />
					<Route path="/planiViajes" component={planiViajesA} />
					<Route path="/nuevoViaje" component={ViajeNuevo} />
					<Route path="/tiposviajes" component={TipoViajes} />
					<Route path="/estado_ruta" component={EstatusRutas} />
					<Route path="/cancelar_viaje" component={CancelacionViaje} />
					<Route path="/editar_viaje" component={CambiarViaje} />
					{this.state.rutas.map(this.makeRoutes)}

				</Switch>

			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empresa') {

			return (
				<Switch>
					<Route path="/nuevoViaje" component={ViajeNuevo} />
					<Route path="/reservaE" component={ReservaEmpre} />
					<Route path="/selecionTipo/:tipo" component={NuevoTipo} />
					<Route path="/selecionRango" component={SelecionRango} />
					<Route path="/costos" component={Costos} />
					<Route path="/adicciones" component={cambioViajes} />
					<Route path="/estado_ruta" component={EstatusRutas} />
					<Route path="/viajes/:uid" component={ViajesEmpleados} />
					<Route path="/empleados" component={Emp_Empleados} />
					<Route path="/reporte_viajes_empresa" component={ReporteGeneralViajesEmpresa} />
					<Route path="/reporte_operacionalA" component={ReporteOperacionalA} />
					<Route path="/cargaemple" component={cargaEmple} />
					<Route path="/planiViajes" component={planiViajesA} />
					<Route path="/" component={Emp_Empleados} />

				</Switch>
			)

		}
		else if (this.state.authUser !== null && this.state.tipo === 'perfil') {
			return (
				<Switch>
					{this.state.rutas.map(this.makeRoutes)}
					<Route path="/" component={Home} />
				</Switch>
			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empleado') {
			return (
				<Switch>
					<Route path="/" component={HomeEmple} />
				</Switch>
			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'socio') {


			return (

				<Switch>
					<Route path="/reporte_viajes_conductores" component={ReporteViajesConductores} />
					<Route path="/reporte_conductores" component={ReporteConductores} />
					<Route path="/reporte_vehiculos" component={ReporteVehiculos} />
				</Switch>



			);

		}

		else {


		}



	}

	updateStateEmpresa(nodo_empresa, nombre_empresa) {
		store.dispatch({
			type: 'STATE_EMPRESA',
			nodo_empresa: nodo_empresa,
			nombre_empresa: nombre_empresa
		});
	}



	render() {

		const { children } = this.props;


		return (
			<div>
			<Offline>
				<div style={{ alignContent: "center", backgroundColor: "#ADA8A8", color: "black", fontSize: "20px", padding: '0.25em', textAlign: "center", display: "block" }}>Sin acceso a internet</div>
			</Offline>
				< Provider store = { store } >
					<div className="principal">
						{this.renderContent()}
						{(this.state.tipo !== null ? this.renderRoutes() : '')}
						<Alert stack={{ limit: 3 }} html={true} />
					</div>
		</Provider >	
			</div>
    );
	}
}


export default withRouter(App);



// WEBPACK FOOTER //
// ./src/Components/App.js